export function parseXml(xml:string):Document {
  const doc=new DOMParser().parseFromString(xml,'application/xml');
  const err=doc.getElementsByTagName('parsererror')[0];
  if(err) throw new Error(`XML parse error: ${err.textContent?.trim()||'unknown'}`);
  return doc;
}
export function localName(node:Node):string{return (node as Element).localName||node.nodeName.replace(/^.*:/,'');}
export function childElements(parent:Node,name?:string):Element[]{
  const out:Element[]=[];for(let n=parent.firstChild;n;n=n.nextSibling)if(n.nodeType===1&&(!name||localName(n)===name))out.push(n as Element);return out;
}
export function child(parent:Node,name:string):Element|null{return childElements(parent,name)[0]??null;}
export function text(parent:Node,name:string):string|null{return child(parent,name)?.textContent??null;}
export function descendants(parent:Element,name:string):Element[]{return Array.from(parent.getElementsByTagName('*')).filter(e=>localName(e)===name);}
export function clone<T extends Node>(node:T):T{return node.cloneNode(true) as T;}
export function attr(el:Element,name:string):string|null{return el.hasAttribute(name)?el.getAttribute(name):null;}
export function remove(el:Element):void{el.parentNode?.removeChild(el);}
